import CircularProgress from '@material-ui/core/CircularProgress';
import { createStyles, withStyles } from '@material-ui/styles';
import cn from 'classnames';
import * as React from 'react';
const styles = (theme) => createStyles({
    loaderWrapper: {
        display: 'flex',
        flex: 1,
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
    },
    root: {
        color: theme.color.primary.main,
    },
});
const Loader = (props) => {
    const { className: classNameProp, size = 60, thickness = 1, classes, testId = 'Loader', ...others } = props;
    const classNames = cn(classes.root, classNameProp);
    return (React.createElement("div", { className: classes.loaderWrapper, "data-testid": testId },
        React.createElement(CircularProgress, { size: size, thickness: thickness, className: classNames, ...others })));
};
export default withStyles(styles)(React.memo(Loader));
//# sourceMappingURL=Loader.js.map